import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class PaymentMethodInstruction extends Instruction {
  constructor ({ name, value }) {
    super({
      name: name || 'PaymentMethod',
      waitForNoLoaders: true,
      type: InstructionTypes.PaymentMethod

    })
    this.value = value
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.value === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    this.value = params.paymentMethod
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      value: this.value
    }
  }
}
